import React from 'react';
const QUESTIONS = ['What should you check when the system runs but doesn\u2019t cool?', 'Where do you start with weak airflow?', 'What should you verify when the compressor won\u2019t start?', 'What does that pressure pattern suggest?', 'What about a frozen coil or short cycling?'];
export function ProblemSection() {
  return <section className="border-y-4 border-hvac/20 bg-white px-4 py-5 sm:py-7" data-id="element-136" data-mp="2vp6euiz1uwbx">
      <div className="mx-auto max-w-3xl" data-id="element-137" data-mp="39gkvij5hilft">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-138" data-mp="39jqjtw6ahjah">
          What if your troubleshooting resources were already ready?
        </h2>
        <p className="mt-2 text-sm font-semibold leading-snug text-charcoal sm:text-base" data-id="element-139" data-mp="3jfjvzeg3jarq">
          You already have the technical knowledge.
        </p>
        <p className="mt-1 text-sm font-medium leading-snug text-charcoal/80 sm:text-base" data-id="element-140" data-mp="1p1ssyxs9vp59">
          The problem is constantly needing the right information to troubleshoot the problem
          in front of you.
        </p>

        <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-141" data-mp="je6c4p9sa246">
          {QUESTIONS.map(q => <li key={q} className="rounded-md border-l-4 border-alert bg-off px-3 py-2 text-sm font-medium leading-snug text-charcoal" data-id="element-142" data-mp="od9kail28ogd">
              {q}
            </li>)}
        </ul>

        <p className="mt-3 text-sm font-medium leading-snug text-charcoal/80 sm:text-base" data-id="element-143" data-mp="x6mkm5lgesch">
          Instead of jumping between scattered resources,{' '}
          <strong className="text-navy" data-id="element-144" data-mp="171wmmtbuqzq9">HVAC DIAGNOSTIC READY™</strong> gives you an organized
          library of visual, ready-to-use diagnostic maps across 6 essential areas of HVAC
          troubleshooting.
        </p>
        <p className="mt-2 text-center font-display text-lg uppercase text-hvac sm:text-2xl" data-id="element-145" data-mp="1g2ugiisktqv4">
          Find it. Follow it. Verify it.
        </p>
      </div>
    </section>;
}